import EmojiPage from '../components/EmojiPage';
import CategoryPage from '../components/CategoryPage';
import CategoryContent from '../components/CategoryContent';
import { icons, emojiPageData, categoryPageData, emojisByCategory } from '../data/pageData';
import { PAGE_TYPE } from '../data/pageIds';

const allData = [emojiPageData, categoryPageData];

export function getStaticPaths() {
  const paths = [];

  for (const dataEntry of allData) {
    for (const id in dataEntry) {
      paths.push({ params: { id } });
    }
  }

  return {
    paths,
    fallback: false,
  };
}

function getProps(id: string) {
  for (const dataEntry of allData) {
    if (dataEntry[id]) {
      return dataEntry[id];
    }
  }
}

export function getStaticProps({ params: { id } }) {
  return { props: { id, ...getProps(id) } };
}

export default function Page(props) {
  const { id, type } = props;

  switch (type) {
    case PAGE_TYPE.category: {
      const emojis = [emojisByCategory[id]];

      return (
        <CategoryPage emojis={emojis} category={id}>
          <CategoryContent category={id} imgs={props.imgs} />
        </CategoryPage>
      );
    }
    case PAGE_TYPE.emoji: {
      const categoryIcon = icons[id];

      return <EmojiPage {...props} CategoryIcon={categoryIcon} />;
    }
  }
}
